// extracted by mini-css-extract-plugin
module.exports = {"root":"MasterControls_root__3QJ-6","label":"MasterControls_label__3Vc5L"};